<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import { useMediaQueryStore } from '~/stores/mediaQuery';
const globalStore = useGlobalStore();
const mediaStore = useMediaQueryStore();
const isTablet = computed(() => mediaStore.isTablet || mediaStore.isMobile);
const isBot = computed(() => globalStore.isBot);
defineProps({
  selectedBase: {
    type: Object,
    required: true,
  },
  catalog: {
    type: Object,
    required: true,
  },
  levelCatalog: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits([
  'levelChange',
  'clickCategories',
  'closeCatalog',
  'search',
]);

function* chunks<T>(array: T[], n: number): IterableIterator<T[]> {
  for (let i = 0; i < array.length; i += n) yield array.slice(i, i + n);
}

// const isShow = computed(() =>
//   props.selectedBase?.url.includes('bytovaya-tehnika')
// );
</script>

<template>
  <div
    v-for="(list, indexCatalog) in catalog"
    :key="indexCatalog"
    class="sub-level"
    :class="{ active: list.title === selectedBase.title }"
  >
    <div class="sub-wrapper">
      <MenuCatalogHeader
        show-desktop
        :title="list.title"
        @close="emit('levelChange')"
        @search="emit('search')"
      />
      <div class="menu-list">
        <div
          v-for="(arr, iter) in chunks(list.children, list.children.length / 3)"
          :key="iter"
          class="arrays"
        >
          <MenuCatalogItem
            v-for="(block, index) in arr"
            :key="index"
            :item="block"
            show-arrow
            is-desktop-heading
            :is-tablet="isTablet"
            blue-hover
            :last="iter === 2 && index === arr.length - 1"
            @click="emit('clickCategories', block)"
          >
            <MenuDesktopLastMenu :items="block.children" />
          </MenuCatalogItem>
        </div>
      </div>
    </div>
    <div v-if="!isBot" class="banners-wrapper">
      <MenuCatalogLogos
        :index-catalog="String(indexCatalog)"
        :is-tablet="isTablet"
        :logos="list.logos"
        @close-catalog="globalStore.setMenuOpen(false)"
      />
      <MenuCatalogBanners
        :banners="list.banners"
        :index-catalog="String(indexCatalog)"
        @close-catalog="globalStore.setMenuOpen(false)"
      />
      <menu-sale-banners
        v-if="false && selectedBase.url === 'bytovaya-tehnika'"
        :selected-base="selectedBase"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sub-level {
  width: 100vw;
  background: $white;
  display: none;
  height: calc((var(--fullvh, 100%)) - 50px - (var(--promobannerheight, 0px)));
  overflow-y: scroll;
  scrollbar-width: none; /* Скрыть скроллбар */
  -ms-overflow-style: none; /* IE и Edge */
  &::-webkit-scrollbar {
    display: none;
    @include xl-block {
      display: initial;
    }
  }
  @include xl-block {
    scrollbar-width: initial;
    -ms-overflow-style: initial;
    width: 100%;
    padding-left: 60px;
    padding-right: 12px;
    padding-bottom: 72px;
    position: relative;
    height: calc(100vh - 96px);
  }

  &.active {
    z-index: 4;
    display: flex;
    flex-direction: column;
    @include xl-block {
      flex-direction: row;
    }
  }
  .sub-wrapper {
    @include xl-block {
      overflow-y: auto;
      width: 100%;
    }
  }

  .menu-list {
    display: grid;
    padding: 0 12px;
    position: relative;
    overflow-y: auto;

    @include xl-block {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0;
    }
    .arrays {
      @include xl-block {
        width: 100%;
      }
    }

    .last-menu {
      display: none;
      margin-top: 20px;
      @include xl-block {
        display: grid;
      }
    }
  }
  .banners-wrapper {
    padding: 0 12px;
    @include xl-block {
      //overflow-y: auto;
      padding: 28px 25px;
      max-width: 287px;
      border-left: 1px solid $achromatic-hover;
    }
    @include xxl-block {
      min-width: 338px;
    }
  }
}
</style>
